export enum UserHosRuleSetActionTypes {
    SET_USER_HOS_RULESETS = "SET_USER_HOS_RULESETS",
    CLEAR_USER_HOS_RULESETS = "CLEAR_USER_HOS_RULESETS"
}
